import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicRenderSharedModule } from '@workflow/dynamic-render/shared/shared.module';
import { DynamicPipeModule } from '@workflow/pipe/dynamic-pipe.module';
import { SilentVerificationComponent } from './silent-verification/silent-verification.component';
import { SharedModule } from '@shared/shared.module';

const components = [SilentVerificationComponent];

@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, SharedModule, DynamicPipeModule, DynamicRenderSharedModule],
  providers: []
})
export class CommonModalsModule {}
